// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__Dm7Yx","footerNav":"Footer_footerNav__0OVN7"};